import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-supervisor-double-visits-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './double-visits-tab.component.html',
  providers: [{ provide: TabComponent, useExisting: SupervisorDoubleVisitsTabComponent }],
})
export class SupervisorDoubleVisitsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Double Visits');

  userId = input.required<string>();
  endpoint = computed(() => `/visits/tables/supervisors-double-visits/${this.userId()}`);

  public async main(): Promise<void> {}
}
